export const events = {
    // from internal components
    onSystemEvent: 'OnSystemEvent',
    onSocketDataReceived: 'SystemSocketDataReceived',

    onTimeChanged: 'ClockVue_TimeUpdated',
    onReconnected: 'onReconnected',
    onClearCache: 'onClearCache',

    // from service
    onJournalUpdated: 'OnJournalUpdated',
    onQuotaUpdated: 'OnQuotaUpdated',
    onQuotaDeleted: 'OnQuotaDeleted',
    onTopicAdded: 'topic:added',

    // topic group events
    onTopicGroupsRecreated: 'OnTopicGroupsRecreated',

    onGroupNodesLoaded: 'OnGroupNodesLoaded', // CHANGED — was onTopicGroupChanged

    onTopicGroupSaveRequested: 'OnTopicGroupSaveRequested',
    onTopicGroupSettingsChanged: 'OnTopicGroupSettingsChanged',
    onTopicGroupCreated: 'OnTopicGroupCreated',
    onTopicGroupDeleted: 'OnTopicGroupDeleted',

    onEntriesAdded: 'OnEntriesAdded',

    // delete flow
    onNoteDeleted: 'OnNoteDeleted',

    // user settings
    onUserSettingsLoaded: 'OnUserSettingsLoaded',
    onUserSettingChanged: 'OnUserSettingChanged', // ADDED — per-key change, see UserSettingsEngine.set()

    // user
    onUserLoaded: 'OnUserLoaded',
    onLogCreated: 'OnLogCreated', // ADDED — replaces Logger_ErrorHappend

    // error handling
    onError: 'OnError',
    onMessage: 'OnMessage',

    OnCardDataUpdated: 'OnCardDataUpdated',
    OnCmcUsageUpdated: 'OnCmcUsageUpdated',
    OnCmcAssetsUpdated: 'OnCmcAssetsUpdated',

    OnPnl3UnmatchedUpdate_v1: 'OnPnl3UnmatchedUpdated_v1',

    // Confirmed met Kimmie (BE) 2026-09-10
    OnPnl3BalanceUpdate_v1: 'OnPnl3BalanceUpdated_v1',

    // BE-naam nog niet bevestigd (KD8.SmartDeviceService) — check bij het wiren van de echte push.
    OnEntityDataChanged: 'OnEntityDataChanged',

    // HomeWizard P1 push, camelCased payload {power, amp, ems}
    OnPowerUsageUpdated: 'OnPowerUsageUpdated',

    // HomeWizard usage summary push (import/export kWh + costs per period)
    OnPowerSummaryUpdated: 'OnPowerSummaryUpdated',

    OnPowerStateUpdated: 'OnPowerStateUpdated',
    OnBatteriesUpdated: 'OnBatteryContextsUpdated',
    OnBatteriesDeleted: 'OnBatteryContextsDeleted',

    // Power schedules push, payload = array of changed PowerSchedule DTOs
    OnPowerSchedulesUpdated: 'OnPowerSchedulesUpdated',

    OnPowerSchedulesDeleted: 'OnPowerSchedulesDeleted',

    // Battery sequences, payload = array of BatSeqMaster / BatSeqDetail DTOs
    OnBatSeqMastersUpdated: 'OnBatSeqMastersUpdated',
    OnBatSeqMastersDeleted: 'OnBatSeqMastersDeleted',
    OnBatSeqDetailsUpdated: 'OnBatSeqDetailsUpdated',
    OnBatSeqDetailsDeleted: 'OnBatSeqDetailsDeleted',

    // Smart plug live state, payload [{rk, power, amp, powered, online, ems}]
    OnPlugStateChanged: 'OnPlugStateChanged',

    // SmartDeviceService RMQ → SignalR, payload same shape as getSettings
    OnDeviceSettingsUpdated: 'OnDeviceSettingsUpdated',

    // KD8 IUserNotifier push, payload Notification {traceId, receiver, message, data, targets, category, createdOn}
    OnNotificationPublished: 'OnNotificationPublished',

    // KD8 plugin heartbeat push, payload = array of PluginState {instance, plugin, state, app, machine, user, env, gcMem, createdOn, modifiedOn}
    OnSystemStateUpdated: 'OnSystemStateUpdated',

    // BuildManagement push via JernyGateway, payload = full array of BuildStatus {rk, name, lastResult, lastNumber, lastSuccessNumber, lastSuccessEms, lastFailedNumber, lastFailedEms, ems}
    OnBuildStatusUpdated: 'OnBuildStatusUpdated',

    // BatteryControl vendor command envs via JernyGateway, payload = array of CmdEnvs {app, machine, envs}
    OnCmdEnvsUpdated: 'OnCmdEnvsUpdated',
};
